import { Drawer } from '@material-ui/core';
import * as React from 'react';
import { FlyoutSaveCancel } from '../../../../components/flyout-components/FlyoutSaveCancel';
import { FlyoutTitle } from '../../../../components/flyout-components/FlyoutTitle';
import { InventorySvc } from '../../../../shared/services/inventory-service';

interface IProps {
    visible: boolean;
    onSuccess: any;
    onClose: any;
    reportId: string;
}

export const ActionUpdateMiscOrders = (props: IProps) => {

    const [service] = React.useState(new InventorySvc());
    const [miscOrdersFile, setMiscOrdersFile] = React.useState<any>();

    const onSave = async () => {

        if (miscOrdersFile) {

            service.updateMiscOrders(props.reportId, miscOrdersFile).then((result) => {
                props.onSuccess();
            });
        }
    };

    /**
     * Cleanup some our state and close the panel
     */
    const onClose = () => {
        props.onClose();
    };


    const setFile = (evt: any) => {
        setMiscOrdersFile(evt.target.files[0]);
    };


    return <Drawer
        anchor="right"
        data-testid="stop-action-basic-info"
        onClose={onClose}
        open={props.visible}>
        <div className="stop-action-drawer mini stop-action-basic-info">

            <FlyoutTitle
                onMobileClose={onClose}
                title="Update Orders" />

            <div className="row">
                <div className="col-md-12">
                    <input
                        id="controlMapFile"
                        accept=".xls, .xlsx"
                        type="file"
                        name="file"
                        onChange={setFile} />
                </div>
            </div>
            <FlyoutSaveCancel
                onSave={onSave}
                onCancel={onClose}
            />
        </div>
    </Drawer>
};
